export default "__VITE_ASSET___lKIDpM8__"